import React, { Component } from 'react'
import {
  Input,
  Form,
  Col,
  Button,
  message,
  Table,
  Select,
  Row,
  Tooltip,
  Popconfirm,
} from 'antd'
import Layouts from './components/Layouts'
import { EditOutlined, CloseOutlined, DeleteOutlined } from '@ant-design/icons'
import apiRequest from './hooks/ApiRequest'
class RiskCover extends Component {
  constructor() {
    super()
    this.state = {
      stampDuty: 0,
      smtpPort: '',
      smtpPassword: '',
      currency: '',
      reinsuranceLimit: 0,
      reinsuranceLimitMail: '',
      smtpDisplayName: '',
      smtpHost: '',
      smtpMail: '',
      allData: [],
      riskItemList: [],
      riskCoverDrop: [],
      newRiskCover: '',
      productId: parseInt(localStorage.getItem('productId')),
      data: [],
      ViewRisk: false,
      ProductSelected: '',
      riskcoveridEdit: 0,
      columns: [
        { key: '1', title: 'Product Name', dataIndex: 'productname' },
        { key: '2', title: 'Cover Name', dataIndex: 'riskname' },
        {
          key: '3',
          title: 'Action',
          render: (_, record) => (
            <>
              <Tooltip title="Edit">
                <Button
                  type="primary"
                  className="edit_btn"
                  onClick={() =>
                    this.handleEditRiskCover(
                      record.productid,
                      record.riskname,
                      record.riskcoverid,
                    )
                  }>
                  <EditOutlined />
                </Button>
              </Tooltip>
              <Popconfirm
                className="delete_btn"
                title="Are you sure you want to delete this record ?"
                onConfirm={() =>
                  this.handleDeleteRiskCover(record.riskcoverid)
                }>
                <Tooltip title="Delete">
                  <Button type="danger" style={{ marginLeft: 8 }}>
                    <DeleteOutlined />
                  </Button>
                </Tooltip>
              </Popconfirm>
            </>
          ),
        },
      ],
    }
    this.productChange = this.productChange.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleEditRiskCover = async (id, name, riskId) => {
    const response = await apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetRiskCoverbyId/0',
      'GET',
    )

    console.log(response)
    if (response.success) {
      const data = response.data

      for (let i = 0; i < data.result.length; i++) {
        if (name === data.result[i].riskname) {
          this.setState({ riskCoverName: data.result[i].riskname })
          this.setState({ ProductSelected: data.result[i].productname })
          this.setState({ productId: id })
          this.setState({ riskcoveridEdit: riskId })
        }
      }
    }

    // fetch(
    //   process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetRiskCoverbyId/0',
    // )
    //   .then(res => res.json())
    //   .then(data => {
    //     for (let i = 0; i < data.result.length; i++) {
    //       if (name === data.result[i].riskname) {
    //         this.setState({ riskCoverName: data.result[i].riskname })
    //         this.setState({ ProductSelected: data.result[i].productname })
    //         this.setState({ productId: id })
    //         this.setState({ riskcoveridEdit: riskId })
    //       }
    //     }
    //   })
  }

  componentDidMount = async () => {
    // fetch(process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetProductsbyId/0,1')
    //   .then(res => res.json())
    //   .then(data => {
    //     this.setState({riskCoverDrop: data})
    //   })

    const response = await apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetRiskCoverbyId/0',
      'GET',
    )

    if (response.success) {
      this.setState({ data: response.data.result })
    }

    const res = await apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts',
      'GET',
    )

    if (res.success) {
      this.setState({ riskCoverDrop: res.data?.data })
    }
  }
  productChange(value) {
    this.setState({ productId: value });
    this.setState({ ProductSelected: value });
  }

  updateRiskCover = async e => {
    e.preventDefault()

    const userId = parseInt(localStorage.getItem('loggedInUserID'))
    const isUpdate = this.state.riskcoveridEdit !== 0
    const payload = {
      productid: this.state.productId,
      riskname: this.state.riskCoverName,
      createdby: userId,
      modifiedby: userId,
      riskcoverid: isUpdate ? this.state.riskcoveridEdit : 0,
      createddate: new Date(),
      modifieddate: new Date(),
      isactive: true,
    }

    const url = isUpdate
      ? `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/UpdateRiskCover/UpdateRiskCover`
      : `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/AddRiskCover/AddRiskCover`

    try {
      const response = await apiRequest(url, 'POST', payload)

      if (response.success) {
        message.success(
          isUpdate
            ? 'Policy Cover Updated Successfully !!'
            : 'Policy Cover Added Successfully !!',
        )
        window.location.reload(false)
      } else {
        message.error(response.error || 'Something went wrong!')
      }
    } catch (err) {
      console.error('API error:', err)
      message.error('Network error, please try again.')
    }
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleDeleteRiskCover = async id => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/DeleteRiskCover/${id}`,
        'GET',
      )

      if (response.success) {
        message.success('Policy Cover Deleted Successfully !!')
        window.location.reload(false)
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Request failed:', error)
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form
    let riskCoverList =
      this.state.riskCoverDrop.length > 0 &&
      this.state.riskCoverDrop.map((item, i) => {
        return (
          //<Select.Option   key={i} value={item.riskcoverid}>{item.riskname}</Select.Option>
          <Select.Option key={i} value={item.productid}>
            {item.productname}
          </Select.Option>
        )
      }, this)
    // console.log(this.state.riskCoverDrop);
    // console.log(riskCoverList);

    return (
      <div title="assets" className="ant-layout-content dashboard">
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={24} md={24} lg={12}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  {' '}
                  Manage Policy Cover
                </h3>
              </div>
            </Col>
          </Row>
        </div>
        <div>
          <Row className="m-t-30 m-b-40">
            <div className="dash-bg-white">
              <Row gutter={[16, 16]}>
                <Col xs={12} sm={24} md={24} lg={10}>
                  <label>Select Product:</label>
                  {this.state.ProductSelected === '' && (
                    <Select
                      placeholder="Select Product"
                      onChange={this.productChange}
                      style={{ display: 'inline' }}>
                      {riskCoverList}
                    </Select>
                  )}
                  {this.state.ProductSelected !== '' && (
                    <Select
                      value={this.state.ProductSelected}
                      placeholder="Select Product"
                      onChange={this.productChange}
                      style={{ display: 'inline' }}>
                      {riskCoverList}
                    </Select>
                  )}
                </Col>
                <Col xs={12} sm={24} md={24} lg={14}>
                  <Form onSubmit={this.updateRiskCover}>
                    <Row gutter={[16, 0]}>
                      <Col xs={12} sm={24} md={24} lg={18}>
                        <Form.Item label="Policy Cover">
                          <Input
                            name="riskCoverName"
                            placeholder="Policy Cover"
                            value={this.state.riskCoverName}
                            onChange={this.handleChange}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={12} sm={24} md={24} lg={6}>
                        <Button htmlType="submit" className="primary m-t-22">
                          Add
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </div>
            <div className="table-grid-bx">
              <Table
                className="table-scroll-auto"
                columns={this.state.columns}
                dataSource={this.state.data}
                pagination={false}
                rowKey="riskcoverid"
              />
            </div>
          </Row>
        </div>
      </div>
    )
  }
}
const WrappedRiskCover = Form.create({ name: 'Homeinsurance_list' })(RiskCover)

export default WrappedRiskCover
